import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';
import { PplusSettingsService } from '@app/shared/common/pplus/services/pplus-settings.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    templateUrl: './default-brand.component.html',
    selector: 'default-brand',
    encapsulation: ViewEncapsulation.None
})
export class DefaultBrandComponent extends AppComponentBase {

    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    pplusLogo: any;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document,
        private pplusSettingsService: PplusSettingsService,
        private domSanitizer: DomSanitizer
    ) {
        super(injector);
        this.pplusLogo = this.pplusSettingsService.logo ? this.domSanitizer.bypassSecurityTrustUrl(this.pplusSettingsService.logo) : '';
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('kt-aside--minimize');
    }
}
